import React from "react"
import {IndexRoute, Link, Redirect, Route, Switch, withRouter} from "react-router-dom";
import LifeAtInnogyEdit from './edit';
import LifeAtInnogyList from './list';

class LifeAtInnogyIndex extends React.Component {

    render() {
        return (
            <Switch>
                <Route path="/life-at-innogy/:id" component={LifeAtInnogyEdit}/>
                <Route path="/life-at-innogy" component={LifeAtInnogyList}/>
                <Redirect to='/life-at-innogy'/>
            </Switch>
        )
    };
}

export default LifeAtInnogyIndex;
